var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"level"},[_c('p',{staticClass:"level-item"},[_c('strong',[_vm._v(_vm._s(this.graphname))])])]),_c('graph',{attrs:{"plotdata":this.plotdata}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }